import React from 'react';
import { ServiceGroup } from '@/types/serviceGroup';
import { GLS } from '../Presentation';

type Props = {
  service: ServiceGroup;
};

export const GLSContainer: React.FC<Props> = ({ service }) => {
  const childProps = {
    service,
  };
  return <GLS {...childProps} />;
};
